import { combineReducers } from 'redux';

import {
    FETCH_APPS_FAILURE,
    FETCH_APPS_REQUEST,
    FETCH_APPS_SUCCESS,
} from '../actions/types/apps-action-types';

function appItems( state = [], action ){
    let newState;
    switch( action.type ){
        case FETCH_APPS_SUCCESS:
            newState = action.apps;
            break;
        case FETCH_APPS_REQUEST:
        case FETCH_APPS_FAILURE:
            newState = [];
            break;
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    appItems,
} );
